<mat-card style="overflow: scroll; ">



    <app-package-dialog ></app-package-dialog>




    <mat-card-content >


        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%;
                width: 100%;color: #2F4395; font-size: 18px;">

<div style="float: left;margin-top:5px;">
    <img src="../../assets/img/morceau/4.png" height="40">
              Package Sponsor
            </div>
            <div style="float: right; cursor: pointer;" (click)="clickedMe()"  >
                <img src="../../assets/img/morceau/edit.png">   
        </div> 

     

       
        </div>

  <div   id="pack">
   
  </div>


    </mat-card-content>
</mat-card>